import {ClassNames, css} from "@emotion/react";
import React from 'react';
import {CSSTransition} from "react-transition-group";
import {CloseIcon, XIcon} from "./components/XIcon";
import {
    Backdrop,
    ModalContent,
    ModalContentWrapper,
    modalEnter,
    modalEnterActive,
    modalExit,
    modalExitActive,
    ModalHeader,
    ModalTitle,
} from './styles';

export interface ModalProps {
    title?: string;
    open: boolean;
    padding?: number | string;
    width?: number | string;

    onClose?(): void;
}

let nModals = 0;
let oldOverflow: string = document.body.style.overflow;
let oldMarginRight: string = document.body.style.marginRight;

export const Modal: React.FC<ModalProps> = ({
    open,
    title,
    children,
    padding = "35px 35px 35px 48px",
    width,
    onClose
}) => {

    const [mouseDown, setMouseDown] = React.useState(false);

    React.useLayoutEffect(() => {
        if(open) {
            nModals++;
            oldOverflow = document.body.style.overflow;
            oldMarginRight = document.body.style.marginRight;
            const scrollbarWidth = document.body.offsetWidth - document.body.clientWidth;
            document.body.style.overflow = "hidden";
            document.body.style.marginRight = scrollbarWidth + "px";
        }
        else {
            nModals = Math.max(0, nModals - 1);
        }
    }, [open]);

    return (
        <ClassNames>
            {({ css: cn}) => (
                <CSSTransition
                    in={open}
                    addEndListener={(node, done) => {
                        node.addEventListener("transitionend", done, false);
                    }}
                    unmountOnExit={true}
                    mountOnEnter={true}
                    onExited={() => {
                        if(nModals === 0) {
                            document.body.style.overflow = oldOverflow;
                            document.body.style.marginRight = oldMarginRight;
                        }
                    }}
                    classNames={{
                        enter: cn(modalEnter),
                        enterActive: cn(modalEnterActive),
                        exit: cn(modalExit),
                        exitActive: cn(modalExitActive),
                    }}
                >
                    <Backdrop onMouseDown={(e) => {
                        if(e.currentTarget === e.target) {
                            setMouseDown(true);
                        }
                    }} onMouseUp={(e) => {
                        if(mouseDown && e.currentTarget === e.target) {
                            onClose?.();
                        }
                        setMouseDown(false);
                    }}>
                        <ModalContentWrapper>
                            <ModalHeader>
                                <ModalTitle>{title}</ModalTitle>
                                <CloseIcon onClick={() => onClose?.()}><XIcon /></CloseIcon>
                            </ModalHeader>
                            <ModalContent css={css({
                                padding,
                                width,
                            })}>
                                {children}
                            </ModalContent>
                        </ModalContentWrapper>
                    </Backdrop>
                </CSSTransition>
            )}
        </ClassNames>
    );
};
